import { queries } from "./queries";
import { mutators } from "./mutators";

let logsChannelId: string | null = null;
let initPromise: Promise<void> | null = null;
let cachedUserId: string | null = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let zeroRef: any = null;

export function setSystemLogZero(zero: unknown) {
  zeroRef = zero;
  // Reset cached state when zero instance changes
  logsChannelId = null;
  initPromise = null;
  cachedUserId = null;
}

async function getOrCreateLogsChannel(
  currentUserId?: string,
): Promise<string | null> {
  if (logsChannelId) return logsChannelId;
  if (!zeroRef) return null;
  if (!currentUserId) return null;

  const workspaces = await zeroRef.run(queries.workspaces.byUser());
  if (workspaces.length === 0) return null;

  const wsId = workspaces[0].id;
  await zeroRef.mutate(
    mutators.actions.ensureWorkspaceSystemLogChannel({
      workspaceId: wsId,
      actorUserId: currentUserId,
    }),
  );

  const channels = await zeroRef.run(queries.channels.byWorkspaceAndUser(wsId));
  const existingLogsChannels = channels.filter(
    (channel: { name: string }) => channel.name === "logs",
  );
  if (existingLogsChannels.length === 0) return null;
  logsChannelId = existingLogsChannels[0].id;
  return logsChannelId;
}

async function doInit(currentUserId?: string) {
  await getOrCreateLogsChannel(currentUserId);
}

export async function initSystemLog(currentUserId?: string) {
  try {
    if (currentUserId) cachedUserId = currentUserId;
    if (!initPromise) {
      initPromise = doInit(currentUserId).catch(() => {
        initPromise = null;
      });
    }
    await initPromise;
  } catch {
    // Silently fail
  }
}

export async function postSystemLog(message: string, currentUserId?: string) {
  try {
    const userId = currentUserId ?? cachedUserId;
    await initSystemLog(userId ?? undefined);
    const channelId = logsChannelId;
    if (!channelId || !zeroRef || !userId) return;

    zeroRef.mutate(
      mutators.actions.postSystemLog({
        channelId,
        actorUserId: userId,
        content: message,
      }),
    );
  } catch {
    // Silently fail
  }
}
